import { Box, Stack } from '@mui/material';
import React from 'react';

import AppointmentDetail from './AppointmentDetail';
import { APPOINTMENT_DETAIL_ICONS, APPOINTMENT_TYPE_ICONS, getAppointmentTypeTranslationMap } from '../utils';
import { FormattedAppointment } from 'FRONTEND/utils/backendApi/Appointments/appointment.types';

const AppointmentListItemDetails = ({ appointment, isPatientUser } : { appointment: FormattedAppointment, isPatientUser: boolean }) => {
  const { appointmentType, patient, location, reason } = appointment;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mt: 1 }}>
      <Stack spacing={1} minWidth={200}>
        <AppointmentDetail StartIcon={APPOINTMENT_TYPE_ICONS[appointmentType]} text={getAppointmentTypeTranslationMap()[appointmentType]} />
        {!isPatientUser && <AppointmentDetail StartIcon={APPOINTMENT_DETAIL_ICONS.person} text={patient?.display} />}
      </Stack>
      <Stack spacing={1}>
        {location && <AppointmentDetail StartIcon={APPOINTMENT_DETAIL_ICONS.location} text={location.display} />}
        {reason && <AppointmentDetail StartIcon={APPOINTMENT_DETAIL_ICONS.healing} text={reason} />}
      </Stack>
    </Box>
  );
};

export default AppointmentListItemDetails;
